function sanitize(str: string) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function match(name: string, search: string) {
  return new RegExp(sanitize(search), "i").test(name);
}

function filterSearch<T extends { name: string } | { label: string }>(
  list: T[],
  search: string,
): T[] {
  return list.filter((item) =>
    match("label" in item ? item.label : item.name, search),
  );
}

export { filterSearch };
